import * as React from 'react';
import "./logoHeading.less";
import { ReactComponent as Logo } from './profitpoint_logo_FA.svg';
import { NavLink } from 'react-router-dom';

export interface LogoHeadingProps {
    subHeading: string;
}

export const LogoHeading = (props: LogoHeadingProps) => {


    return <div className="the-header">
        <div className="top">
            <NavLink to="/">
                <Logo />
            </NavLink>
        </div>
        <div className="sub-heading">{props.subHeading}</div>
    </div>

}